import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { Plate } from '../models/plate';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MachineStatus } from '../apg-machine-status/model/machine-status';
import { BBResponseContainer } from '../carrier/response-container';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlateStatusService {

  PLATE_PREPARATION_API = environment.BB_SAMPLE_PROCESSING_API

constructor(
  private httpClient: HttpClient) { }

  fetchPlates(labId:string): Observable<Plate[]>{

    let url = this.PLATE_PREPARATION_API+'plateStatus/'+labId;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as Plate[]));
  }

}
